import * as STATE from 'constants/stateNames'
import { useTypedSelector } from 'etc/reducers'
import { getDataFromState } from 'utils/getTyped'
import { flatten, map, path, pathOr, pipe, prop, propOr } from 'ramda'
import { TPermissionItem } from 'types'
import { TUserInfo } from 'types/models'

const getCodeNames = pipe(
  path<TPermissionItem[]>(['permissions']),
  map(prop('codename')),
)
const EMPTY_ARR = []
const useUserPerms = () => {
  const user = useTypedSelector(state => getDataFromState(STATE.USER_INFO, state))

  const userInfo = path<TUserInfo>(['data'], user)
  const permissionList = pipe(
    pathOr(EMPTY_ARR, ['data', 'role', 'groups']),
    map(getCodeNames),
    flatten
  )(user)

  const isSuperuser = propOr(false, 'isSuperuser', userInfo)
  return [permissionList, isSuperuser]
}

export default useUserPerms
